import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Alert, Spinner } from 'react-bootstrap'
import axiosInstance from '../services/axiosInterceptor'
import OfficialDocLayout from './print/OfficialDocLayout'
import { fmtDateTHFull } from './aoShared'

// พิมพ์สมุดหมายเหตุรายวันแบบรายเดือน (?month=YYYY-MM)
export default function DailyLogPrint() {
  const [searchParams] = useSearchParams()
  const month = searchParams.get('month') || new Date().toLocaleDateString('en-CA').slice(0, 7)
  const [logs, setLogs] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    const [y, m] = month.split('-')
    axiosInstance.get(`/api/ao/daily-logs?year=${y}&month=${Number(m)}`)
      .then(res => {
        if (res.data.success) setLogs([...res.data.data].sort((a, b) => a.dl_date.localeCompare(b.dl_date)))
      })
      .catch(err => setError(err.response?.data?.message || 'โหลดข้อมูลไม่สำเร็จ'))
  }, [month])

  if (error) return <div className="p-4"><Alert variant="danger">{error}</Alert></div>
  if (!logs) return <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>

  const monthLabel = new Date(`${month}-01`).toLocaleDateString('th-TH', { year: 'numeric', month: 'long' })

  return (
    <OfficialDocLayout title={`สมุดหมายเหตุรายวัน ประจำเดือน${monthLabel}`} backLink="/admin-office/daily-log">
      {logs.length === 0 ? (
        <div className="text-muted" style={{ textAlign: 'center', marginTop: 20 }}>— ไม่มีบันทึกในเดือนนี้ —</div>
      ) : (
        logs.map(l => (
          <div key={l.dl_id} style={{ marginTop: 16, borderBottom: '1px solid #999', paddingBottom: 10, breakInside: 'avoid' }}>
            <div style={{ fontWeight: 'bold' }}>วัน{fmtDateTHFull(l.dl_date)}</div>
            {(l.dl_teacher_present !== null || l.dl_student_present !== null) && (
              <div>
                สถิติ: ครูมา {l.dl_teacher_present ?? '-'} คน ลา/ขาด {l.dl_teacher_absent ?? '-'} คน ·
                นักเรียนมา {l.dl_student_present ?? '-'} คน ขาด {l.dl_student_absent ?? '-'} คน
              </div>
            )}
            <div style={{ whiteSpace: 'pre-wrap' }}>{l.dl_content || '—'}</div>
            {l.dl_remark && <div>หมายเหตุ: {l.dl_remark}</div>}
            <table style={{ width: '100%', marginTop: 8 }}>
              <tbody>
                <tr>
                  <td style={{ width: '50%', textAlign: 'center' }}>
                    <div>ลงชื่อ ................................ ผู้บันทึก</div>
                    <div>({l.recorded_by_name || '................................'})</div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <div>ลงชื่อ ................................ ผู้อำนวยการ</div>
                    <div>({l.signed_by_name || '................................'})</div>
                    {l.dl_sign_note && <div style={{ fontSize: '13pt' }}>ความเห็น: {l.dl_sign_note}</div>}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ))
      )}
    </OfficialDocLayout>
  )
}
